/* AFORDA favourites: guest-browser storage, saved cards, and accessible toast. */
(() => {
  if (window.__afordaRelatedFavouritesBound) return;
  window.__afordaRelatedFavouritesBound = true;
  const KEY='aforda:favourite-products:v1';
  const DATA_KEY='aforda:favourite-products-data:v1';
  const SELECTOR='.aforda-rec-card__favorite[data-product-id]';
  const PAGE='/pages/favourites';
  const toArray=(v)=>Array.isArray(v)?v.map(String):[];
  const parse=(key,fallback)=>{try {const v=JSON.parse(localStorage.getItem(key));return v===null?fallback:v;}catch(_){return fallback;}};
  let ids=toArray(parse(KEY,[]));
  let info=parse(DATA_KEY,{});
  if(!info || Array.isArray(info) || typeof info!=='object') info={};
  const legacy={
    '15464118780189':'adidas-samba-xlg-cloud-white-core-black-gum',
    '15470539473181':'yeezy-slide-by-kanye-ys-01-chocolate',
    '15470748827933':'yeezy-slide-by-kanye-ys-01-black',
    '15470749286685':'yeezy-slide-by-kanye-ys-01-cream',
    '15470749352221':'yeezy-slide-by-kanye-ys-01-fudge',
    '15470749450525':'yeezy-slide-by-kanye-ys-01-grey',
    '15470749516061':'yeezy-slide-by-kanye-ys-01-blue'
  };
  const unique=()=>{ids=[...new Set(ids)];};
  unique();
  const save=()=>{try{localStorage.setItem(KEY,JSON.stringify(ids));localStorage.setItem(DATA_KEY,JSON.stringify(info));}catch(_){}};
  const updateButtons=(root=document)=>{
    const btns=root.matches&&root.matches(SELECTOR)?[root]:root.querySelectorAll?root.querySelectorAll(SELECTOR):[];
    btns.forEach(btn=>{
      const on=ids.includes(btn.dataset.productId);
      btn.setAttribute('aria-pressed',on?'true':'false');
      btn.setAttribute('aria-label', (on?'Remove ':'Add ')+(btn.dataset.productTitle||'product')+(on?' from favourites':' to favourites'));
      btn.title=on?'Remove from favourites':'Add to favourites';
    });
  };
  let toastTimer;
  function toast(added){
    let el=document.getElementById('aforda-fav-toast');
    if(!el){
      el=document.createElement('div');el.id='aforda-fav-toast';el.className='aforda-fav-toast';el.setAttribute('role','status');
      el.innerHTML='<span aria-hidden="true">♥</span><div class="aforda-fav-toast-text"><strong></strong><span>Saved to your collection.</span></div><a href="/pages/favourites">View favourites →</a><button class="aforda-fav-toast-close" type="button" aria-label="Dismiss">×</button>';
      el.querySelector('button').addEventListener('click',()=>{el.hidden=true;});
      document.body.appendChild(el);
    }
    el.querySelector('strong').textContent=added?'Added to favourites':'Removed from favourites';
    el.querySelector('.aforda-fav-toast-text span').textContent=added?'Saved to your collection.':'Your saved list has been updated.';
    el.hidden=false;
    clearTimeout(toastTimer);toastTimer=setTimeout(()=>{el.hidden=true;},4300);
  }
  const safeRecordFromButton=(btn)=>({
    title:btn.dataset.productTitle||'Saved product',
    handle:btn.dataset.productHandle||'',
    url:btn.dataset.productUrl||'',
    image:btn.dataset.productImage||'',
    price:btn.dataset.productPrice||''
  });
  function onToggle(id,record){
    if(ids.includes(id)){ids=ids.filter(x=>x!==id);delete info[id];save();updateButtons();renderPage();toast(false);}
    else{ids.unshift(id);if(record)info[id]=record;save();updateButtons();renderPage();toast(true);}
  }
  function productURL(record){
    let handle=record?.handle||'';
    if(handle && /^[a-z0-9-]+$/i.test(handle))return '/products/'+handle;
    const url=String(record?.url||'');
    return /^\/products\/[a-z0-9-]+(?:\?.*)?$/i.test(url)?url:'';
  }
  function imageURL(record){
    const url=String(record?.image||'');
    if(url.startsWith('/cdn/'))return url;
    try {const u=new URL(url,location.origin);
      if(u.protocol==='https:' && (u.origin===location.origin || u.hostname==='cdn.shopify.com' || u.hostname.endsWith('.shopifycdn.net')))return u.href;
    }catch(_){}
    return '';
  }
  const hsvg='<svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  let catalog={};
  function getCatalog(){
    const el=document.getElementById('aforda-favourites-catalog');
    if(!el)return;
    try{const items=JSON.parse(el.textContent);for(const p of items){catalog[String(p.id)]=p;}}catch(_){}
  }
  function recordFor(id){return info[id]||catalog[id]||{handle:legacy[id]||'',title:'Saved product',price:'',image:''};}
  function renderPage(){
    const area=document.getElementById('aforda-favourites-results');
    if(!area)return;
    const empty=document.getElementById('aforda-favourites-empty');
    const clear=document.getElementById('aforda-favourites-clear');
    const count=document.getElementById('aforda-favourites-count');
    if(count)count.textContent='('+ids.length+')';
    if(clear)clear.hidden=!ids.length;
    area.replaceChildren();
    if(empty)empty.hidden=ids.length>0;
    for(const id of ids){
      const p=recordFor(id);const href=productURL(p),src=imageURL(p);
      const article=document.createElement('article');article.className='aforda-fav-item';
      const frame=document.createElement(href?'a':'div');frame.className='aforda-fav-photo';
      if(href){frame.href=href;frame.setAttribute('aria-label','View '+(p.title||'saved product'));}
      if(src){const img=document.createElement('img');img.loading='lazy';img.src=src;img.alt=p.title||'Saved product';frame.appendChild(img);}
      const remove=document.createElement('button');remove.type='button';remove.className='aforda-fav-remove';remove.setAttribute('aria-label','Remove '+(p.title||'product')+' from favourites');remove.innerHTML=hsvg;remove.dataset.id=id;remove.addEventListener('click',ev=>{ev.preventDefault();ev.stopPropagation();onToggle(id);});
      const photoWrap=document.createElement('div');photoWrap.className='aforda-fav-photo';photoWrap.style.position='relative';
      frame.className='aforda-fav-photo';frame.style.border='none';frame.style.borderRadius='inherit';
      photoWrap.appendChild(frame);photoWrap.appendChild(remove);
      const details=document.createElement(href?'a':'div');details.className='aforda-fav-details';if(href)details.href=href;
      const name=document.createElement('span');name.className='aforda-fav-name';name.textContent=p.title||'Saved product';
      const price=document.createElement('span');price.className='aforda-fav-price';price.textContent=p.price||'View product for price';
      details.append(name,price);article.append(photoWrap,details);area.appendChild(article);
    }
  }
  async function refreshMissingDetails(){
    for(const id of ids){
      const rec=recordFor(id);
      const handle=rec.handle||legacy[id];
      if(!handle||!/^[a-z0-9-]+$/i.test(handle))continue;
      if(info[id]?.title && info[id]?.image && info[id]?.price)continue;
      try{
        const response=await fetch('/products/'+handle+'.js',{credentials:'same-origin'});
        if(!response.ok)continue;
        const product=await response.json();
        if(!ids.includes(id))continue;
        info[id]={
          title:product.title||rec.title,
          handle,
          url:'/products/'+handle,
          image:product.featured_image||rec.image||'',
          price: typeof product.price==='number' ? (product.price_varies?'From ':'')+new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(product.price/100) : rec.price
        };
        save();renderPage();
      }catch(_){}
    }
  }
  document.addEventListener('click',(ev)=>{
    const btn=ev.target.closest?.(SELECTOR);
    if(!btn)return;
    ev.preventDefault();ev.stopPropagation();
    const id=btn.dataset.productId;
    if(id)onToggle(id,safeRecordFromButton(btn));
  });
  window.addEventListener('storage',ev=>{
    if(ev.key===KEY||ev.key===DATA_KEY||ev.key===null){ids=toArray(parse(KEY,[]));unique();info=parse(DATA_KEY,{})||{};updateButtons();renderPage();}
  });
  function init(){
    getCatalog();
    updateButtons();renderPage();refreshMissingDetails();
    const clear=document.getElementById('aforda-favourites-clear');
    if(clear)clear.addEventListener('click',()=>{
      if(ids.length&&window.confirm('Remove all saved favourites from this browser?')){
        ids=[];info={};save();updateButtons();renderPage();
      }
    });
    const observer=new MutationObserver(changes=>{
      for(const change of changes)for(const node of change.addedNodes)if(node.nodeType===1)updateButtons(node);
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();